export default {
    WorkBench: {
        navtest: 'test',
    },
}